module.exports = __webpack_public_path__ + "static/img/1.7b2588b.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/staff/1.jpg
// module id = 194
// module chunks = 1